// src/admin/views/OrganizationListView.js
import { useEffect, useState } from 'react'
import { FiPlus } from 'react-icons/fi'
import { useNavigate } from 'react-router-dom'
import apiClient from '../../global/utils/apiClient'
import PageHeader from '../components/PageHeader'

function OrganizationListView() {
  const [orgData, setOrgData] = useState([])
  const navigate = useNavigate()

  useEffect(() => {
    // Fetch golfer data from the API when the component mounts
    apiClient.get('/gskapi/org/findAllOrgs')
      .then((response) => {
        setOrgData(response.data)
      })
      .catch((error) => {
        console.error('Error fetching organization data:', error)
      })
  }, [])

  return (
    <>
      <PageHeader pageName="Organizations" backTo="/admin" />
      <div className="add-button-container" style={{ marginTop: '20px' }}>
        <button className="btn btn-primary" onClick={() => navigate(`/admin/org`)}>
          <FiPlus style={{ marginRight: '8px' }} /> Add Organization
        </button>
      </div>
      <div className="admin-list">
        {orgData.map((org) => (
          <div
            key={org.orgId}
            className="admin-list-item"
            onClick={() => navigate(`/admin/org?orgId=${org.orgId}`)}
          >
            <span className="admin-list-item-name">{org.orgName}</span>
            <span className="admin-list-item-arrow">›</span>
          </div>
        ))}
      </div>
    </>
  )
}

export default OrganizationListView
